import { CanvasConfig, CanvasProps } from '@editor/interfaces/editor'

import { usePolylineSelector } from '../../store/selector'
import { PolylineToolMode } from '../store/core'
import useCrackDetectionMainCanvas from './CrackDetection/useMainCanvas'
import usePolylineMainCanvas from './Polyline/useMainCanvas'

const useMainCanvas = (props: CanvasProps): CanvasConfig => {
  // Store
  const mode = usePolylineSelector((state) => state.core.mode)

  // Bring in stuff from each polyline and polygon hooks
  const polyline = usePolylineMainCanvas(props)
  const crackDetection = useCrackDetectionMainCanvas()

  return {
    objects: {
      pointClouds: [...(polyline.objects?.pointClouds || []), ...(crackDetection.objects?.pointClouds || [])],
      labels: [...(polyline.objects?.labels || []), ...(crackDetection.objects?.labels || [])],
      circleAnchors: [...(polyline.objects?.circleAnchors || []), ...(crackDetection.objects?.circleAnchors || [])],
      polylines: [...(polyline.objects?.polylines || []), ...(crackDetection.objects?.polylines || [])],
      polygonPlaneMeshesV2: [
        ...(polyline.objects?.polygonPlaneMeshesV2 || []),
        ...(crackDetection.objects?.polygonPlaneMeshesV2 || []),
      ],
    },
    events: mode === PolylineToolMode.Draw ? polyline.events : crackDetection.events,
  }
}

export default useMainCanvas
